import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router";
// import Ecommerce from "./pages/Dashboard/Ecommerce";
import ErrorBoundary from "./components/ErrorBoundary";
import { ToastProvider } from "./contexts/ToastContext";
import { WorkspaceProvider } from "./contexts/WorkspaceContext";
import Stocks from "./pages/Dashboard/Stocks";
import Crm from "./pages/Dashboard/Crm";
import Marketing from "./pages/Dashboard/Marketing";
import Analytics from "./pages/Dashboard/Analytics";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import NotFound from "./pages/OtherPage/NotFound";
import Carousel from "./pages/UiElements/Carousel";
import Maintenance from "./pages/OtherPage/Maintenance";
import FiveZeroZero from "./pages/OtherPage/FiveZeroZero";
import FiveZeroThree from "./pages/OtherPage/FiveZeroThree";
import Videos from "./pages/UiElements/Videos";
import Images from "./pages/UiElements/Images";
import Alerts from "./pages/UiElements/Alerts";
import Badges from "./pages/UiElements/Badges";
import Pagination from "./pages/UiElements/Pagination";
import Avatars from "./pages/UiElements/Avatars";
import Buttons from "./pages/UiElements/Buttons";
import ButtonsGroup from "./pages/UiElements/ButtonsGroup";
import Notifications from "./pages/UiElements/Notifications";
import LineChart from "./pages/Charts/LineChart";
import BarChart from "./pages/Charts/BarChart";
import PieChart from "./pages/Charts/PieChart";
import Invoices from "./pages/Invoices";
import ComingSoon from "./pages/OtherPage/ComingSoon";
import FileManager from "./pages/FileManager";
import Calendar from "./pages/Calendar";
import BasicTables from "./pages/Tables/BasicTables";
import DataTables from "./pages/Tables/DataTables";
import PricingTables from "./pages/PricingTables";
import Faqs from "./pages/Faqs";
import Chats from "./pages/Chat/Chats";
import FormElements from "./pages/Forms/FormElements";
import FormLayout from "./pages/Forms/FormLayout";
import Blank from "./pages/Blank";
import EmailInbox from "./pages/Email/EmailInbox";
import EmailDetails from "./pages/Email/EmailDetails";

import TaskKanban from "./pages/Task/TaskKanban";
import BreadCrumb from "./pages/UiElements/BreadCrumb";
import Cards from "./pages/UiElements/Cards";
import Dropdowns from "./pages/UiElements/Dropdowns";
import Links from "./pages/UiElements/Links";
import Lists from "./pages/UiElements/Lists";
import Popovers from "./pages/UiElements/Popovers";
import Progressbar from "./pages/UiElements/Progressbar";
import Ribbons from "./pages/UiElements/Ribbons";
import Spinners from "./pages/UiElements/Spinners";
import Tabs from "./pages/UiElements/Tabs";
import Tooltips from "./pages/UiElements/Tooltips";
import Modals from "./pages/UiElements/Modals";
import ResetPassword from "./pages/AuthPages/ResetPassword";
import TwoStepVerification from "./pages/AuthPages/TwoStepVerification";
import Success from "./pages/OtherPage/Success";
import AppLayout from "./layout/AppLayout";
import AlternativeLayout from "./layout/AlternativeLayout";
import { ScrollToTop } from "./components/common/ScrollToTop";
import TaskList from "./pages/Task/TaskList";
import Regulagent from "./pages/Dashboard/Regulagent";
import Logistics from "./pages/Dashboard/Logistics";
import TextGeneratorPage from "./pages/Ai/TextGenerator";
import ImageGeneratorPage from "./pages/Ai/ImageGenerator";
import CodeGeneratorPage from "./pages/Ai/CodeGenerator";
import VideoGeneratorPage from "./pages/Ai/VideoGenerator";
import ProductList from "./pages/Ecommerce/ProductList";
import AddProduct from "./pages/Ecommerce/AddProduct";
import Billing from "./pages/Ecommerce/Billing";
import SingleInvoice from "./pages/Ecommerce/SingleInvoice";
import CreateInvoice from "./pages/Ecommerce/CreateInvoice";
import Transactions from "./pages/Ecommerce/Transactions";
import SingleTransaction from "./pages/Ecommerce/SingleTransaction";
import TicketList from "./pages/Support/TicketList";
import TicketReply from "./pages/Support/TicketReply";
import Integrations from "./pages/OtherPage/Integrations";
import ApiKeys from "./pages/OtherPage/ApiKeys";
import Saas from "./pages/Dashboard/Saas";
import WellRegistry from "./pages/Regulagent/WellRegistry";
import Policies from "./pages/Regulagent/Policies";
import PlanGeneration from "./pages/Regulagent/PlanGeneration";
import PlanDetails from "./pages/Regulagent/PlanDetails";
import WellDetail from "./pages/Regulagent/WellDetail";
import Workspaces from "./pages/Regulagent/Workspaces";
import Settings from "./pages/Regulagent/Settings";
import CreateFiling from "./pages/Regulagent/CreateFiling";
import Filings from "./pages/Regulagent/Filings";

import Research from "./pages/Regulagent/Research";
import C103Details from "./pages/Regulagent/C103Details";
import SubsequentReport from "./pages/Regulagent/SubsequentReport";
import W3WizardList from "./pages/Regulagent/W3WizardList";
import W3WizardNew from "./pages/Regulagent/W3WizardNew";
import W3Wizard from "./pages/Regulagent/W3Wizard";
import Intelligence from "./pages/Regulagent/Intelligence";
import ManualWBDList from "./pages/Regulagent/ManualWBDList";
import ManualWBDEditor from "./pages/Regulagent/ManualWBDEditor";

export default function App() {
  return (
    <ToastProvider>
      <WorkspaceProvider>
      <Router>
        <ScrollToTop />
        <ErrorBoundary>
          <Routes>
            {/* Dashboard Layout */}
            <Route element={<AppLayout />}>
            <Route index path="/" element={<Regulagent />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/crm" element={<Crm />} />
            <Route path="/stocks" element={<Stocks />} />
            <Route path="/saas" element={<Saas />} />
            <Route path="/regulagent" element={<Regulagent />} />
            <Route path="/plan-generation" element={<PlanGeneration />} />
            <Route path="/plan/:planId" element={<PlanDetails />} />
            <Route path="/c103/:formId" element={<C103Details />} />
            <Route path="/subsequent-report/:formId" element={<SubsequentReport />} />
            <Route path="/w3-wizard" element={<W3WizardList />} />
            <Route path="/w3-wizard/new" element={<W3WizardNew />} />
            <Route path="/w3-wizard/:sessionId" element={<W3Wizard />} />
            <Route path="/filings" element={<Filings />} />
            <Route path="/filings/new" element={<CreateFiling />} />
            <Route path="/filing-tracker" element={<Navigate to="/filings" replace />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/well-registry" element={<WellRegistry />} />
            <Route path="/well/:api14" element={<WellDetail />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/workspaces" element={<Workspaces />} />
            <Route path="/nm-lookup" element={<Navigate to="/research" replace />} />
            <Route path="/research" element={<Research />} />
            <Route path="/research/:sessionId" element={<Research />} />
            <Route path="/intelligence" element={<Intelligence />} />
            <Route path="/manual-wbd" element={<ManualWBDList />} />
            <Route path="/manual-wbd/new" element={<ManualWBDEditor />} />
            <Route path="/manual-wbd/:id" element={<ManualWBDEditor />} />
            <Route path="/logistics" element={<Logistics />} />

            <Route path="/calendar" element={<Calendar />} />
            <Route path="/invoice" element={<Invoices />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/chat" element={<Chats />} />
            <Route path="/file-manager" element={<FileManager />} />

            {/* E-commerce */}
            <Route path="/products-list" element={<ProductList />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/single-invoice" element={<SingleInvoice />} />
            <Route path="/create-invoice" element={<CreateInvoice />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/single-transaction" element={<SingleTransaction />} />

            {/* Support */}
            <Route path="/support-tickets" element={<TicketList />} />
            <Route path="/support-ticket-reply" element={<TicketReply />} />

            {/* Others Page */}
            <Route path="/faq" element={<Faqs />} />
            <Route path="/pricing-tables" element={<PricingTables />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/api-keys" element={<ApiKeys />} />
            <Route path="/blank" element={<Blank />} />

            {/* Forms */}
            <Route path="/form-elements" element={<FormElements />} />
            <Route path="/form-layout" element={<FormLayout />} />

            {/* Applications */}
            <Route path="/task-list" element={<TaskList />} />
            <Route path="/task-kanban" element={<TaskKanban />} />

            {/* Email */}
            <Route path="/inbox" element={<EmailInbox />} />
            <Route path="/inbox-details" element={<EmailDetails />} />

            {/* Tables */}
            <Route path="/basic-tables" element={<BasicTables />} />
            <Route path="/data-tables" element={<DataTables />} />

            {/* Ui Elements */}
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/badge" element={<Badges />} />
            <Route path="/breadcrumb" element={<BreadCrumb />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/buttons-group" element={<ButtonsGroup />} />
            <Route path="/cards" element={<Cards />} />
            <Route path="/carousel" element={<Carousel />} />
            <Route path="/dropdowns" element={<Dropdowns />} />
            <Route path="/images" element={<Images />} />
            <Route path="/links" element={<Links />} />
            <Route path="/list" element={<Lists />} />
            <Route path="/modals" element={<Modals />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/pagination" element={<Pagination />} />
            <Route path="/popovers" element={<Popovers />} />
            <Route path="/progress-bar" element={<Progressbar />} />
            <Route path="/ribbons" element={<Ribbons />} />
            <Route path="/spinners" element={<Spinners />} />
            <Route path="/tabs" element={<Tabs />} />
            <Route path="/tooltips" element={<Tooltips />} />
            <Route path="/videos" element={<Videos />} />

            {/* Charts */}
            <Route path="/line-chart" element={<LineChart />} />
            <Route path="/bar-chart" element={<BarChart />} />
            <Route path="/pie-chart" element={<PieChart />} />
          </Route>

          {/* Alternative Layout - for special pages */}
          <Route element={<AlternativeLayout />}>
            {/* AI Generator */}
            <Route path="/text-generator" element={<TextGeneratorPage />} />
            <Route path="/image-generator" element={<ImageGeneratorPage />} />
            <Route path="/code-generator" element={<CodeGeneratorPage />} />
            <Route path="/video-generator" element={<VideoGeneratorPage />} />
          </Route>

          {/* Auth Layout */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/two-step-verification"
            element={<TwoStepVerification />}
          />

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/success" element={<Success />} />
          <Route path="/five-zero-zero" element={<FiveZeroZero />} />
          <Route path="/five-zero-three" element={<FiveZeroThree />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          </Routes>
        </ErrorBoundary>
      </Router>
      </WorkspaceProvider>
    </ToastProvider>
  );
}
